import { mutator } from 'satcheljs';
import { openBoardEditorDialog, closeBoardEditorDialog, setName, setLoadState } from './actions';
import { BoardEditorLoadState } from './schema';
import getStore from './store';

mutator(openBoardEditorDialog, ({ projectInfo }) => {
    const store = getStore();
    store.isOpen = true;

    if (projectInfo) {
        const { projectId, name } = projectInfo;
        if (projectId) {
            store.projectId = projectId;
        }

        if (name) {
            store.name = name;
        }
    }
});

mutator(closeBoardEditorDialog, () => {
    const store = getStore();
    store.isOpen = false;
    store.projectId = undefined;
    store.name = '';
    store.loadState = BoardEditorLoadState.Idle;
});

mutator(setName, ({ newName }) => {
    getStore().name = newName ?? '';
});

mutator(setLoadState, ({ loadState }) => {
    getStore().loadState = loadState;
});
